import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared';
import { Core2Config } from '../../shared';
import { SalesDebitNoteFileImportHelperContainerModel } from '../../../../../../models/aggregates/erp/sales-debit-note-file-import/index';

@Injectable({
  providedIn: 'root'
})
export class SalesDebitNoteFileImportHelperService extends BaseApiTemplateService<SalesDebitNoteFileImportHelperContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-sales-debit-note/import-file-hdr/helper/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-sales-debit-note/import-file-hdr/helper/backoffice-ep';
    this.httpClient = http;
  }
}